import gql from 'graphql-tag';

export const calculateSchoolYears = () => {
  const currentDateObj = new Date();
  const currentMonth = currentDateObj.getMonth() + 1;
  const currentDate = currentDateObj.getDate();
  const currentYear = currentDateObj.getFullYear();
  const schoolYears = [];

  let currentSchoolYear;
  if (currentMonth > 7) {
    currentSchoolYear = currentYear;
  } else if (currentMonth === 7 && currentDate >= 15) {
    currentSchoolYear = currentYear;
  } else {
    currentSchoolYear = currentYear - 1;
  }

  for (let i = 0; i < 5; i += 1) {
    const schoolYearValue = currentSchoolYear - i;
    schoolYears.push({
      text: `${schoolYearValue}-${schoolYearValue + 1}`,
      value: schoolYearValue,
    });
  }

  return schoolYears;
};
export const HISTORICAL_CHOICES = [
  { value: 7 },
  { value: 14 },
  { value: 30 },
  { value: 60 },
  { value: 90 },
];

export const SHOW_YEAR = 'YEAR';
export const SHOW_LAST_EXPORT = 'LAST_EXPORT';
export const SHOW_RECENT = 'RECENT';

export const SCHOOL_YEARS = calculateSchoolYears();
export const LIMIT = 25;
export const DOWNLOAD_LIMIT = 1000;

export const SINCE_LAST_EXPORT = 'sinceLastExport';
export const HISTORICAL = 'historical';
export const BY_SCHOOL_YEAR = 'bySchoolYear';

export const STUDENT_CONNECTION_FRAGMENT = gql`
  fragment AMStudentResults on AMStudentConnection {
    id
    firstName
    lastName
    email
    phone
    address
    city
    state
    zip
    ethnicity
    gender
    birthDate
    schoolName
    ceeb
    graduationYear
    gpa
    contact
    creditsEarned
    transferBy
    source
    disconnectedStatus
    dateUpdated
    dateSubmitted
    majors {
      name
    }
  }
`;
